var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.modalClass, on: { click: _vm.clickModal } }, [
    _c(
      "div",
      {
        ref: "dialog",
        class: ["dialog", { chrome: _vm.showDialogChrome }],
        style: _vm.styleObject,
        attrs: { id: _vm.dialogModel.cid },
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _vm.showDialogChrome
          ? _c(
              "div",
              {
                ref: "dialogHeader",
                class: ["header", { picker: _vm.dialogModel.picker }],
              },
              [
                _c("div", { class: [{ closer: _vm.dialogModel.hasclose }] }, [
                  _vm.dialogModel.hasclose
                    ? _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          on: { click: _vm.checkClose },
                        },
                        [_vm._v("\n\t\t\t\t\tclose\n\t\t\t\t")]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                typeof _vm.dialogModel.title !== "undefined"
                  ? _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.dialogModel.title) +
                          "\n\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "dialogBody",
            class: ["body", { noBodyPadding: _vm.dialogModel.noBodyPadding }],
            style: Object.assign(
              {},
              { "max-height": _vm.maxBodyHeight + "px" },
              _vm.bodyStyle
            ),
          },
          [
            _vm.dialogModel.vueView
              ? _c(
                  _vm.dialogModel.vueView,
                  _vm._g(
                    _vm._b(
                      {
                        ref: "component",
                        tag: "Component",
                        attrs: { "dialog-model": _vm.dialogModel },
                        on: {
                          closeDialog: _vm.closeDialog,
                          updateDialog: _vm.centerScreen,
                        },
                      },
                      "Component",
                      _vm.componentProps,
                      false
                    ),
                    Object.assign({}, _vm.componentListeners)
                  )
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.dialogModel.vueView && _vm.dialogModel.type == "date"
              ? _c(
                  "Pikaday",
                  _vm._b(
                    {
                      on: {
                        onSelect: function ($event) {
                          return _vm.changeDate($event)
                        },
                      },
                    },
                    "Pikaday",
                    _vm.componentProps,
                    false
                  )
                )
              : !_vm.dialogModel.vueView && _vm.dialogModel.type == "prompt"
              ? _c(
                  "div",
                  [
                    _vm.bodyText
                      ? _c("div", { staticClass: "bodyBox" }, [
                          _c("pre", [_vm._v(_vm._s(_vm.bodyText))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.dialogModel.data, function (field) {
                      return _c(
                        "div",
                        { key: field.id, staticClass: "promptWrapper" },
                        [
                          field.inputLabel
                            ? _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(field.inputLabel) +
                                    "\n\t\t\t\t\t\t"
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            ref: field.id,
                            refInFor: true,
                            attrs: {
                              placeholder: field.inputPlaceholder,
                              autofocus: field.autoFocus,
                            },
                            domProps: { value: field.value },
                          }),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : !_vm.dialogModel.vueView && _vm.dialogModel.type == "progress"
              ? _c("div", [
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.progressLabel) +
                        ": " +
                        _vm._s(String(_vm.progressValue)) +
                        "%\n\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.progressValue > 0
                    ? _c("div", { staticClass: "progressBar" }, [
                        _c(
                          "div",
                          {
                            staticClass: "progressValue",
                            style: { width: _vm.progressValue + "%" },
                          },
                          [_vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t")]
                        ),
                      ])
                    : _c("div", [
                        _c("br"),
                        _vm._v(" "),
                        _c("div", { staticClass: "loadingBar" }),
                      ]),
                ])
              : !_vm.dialogModel.vueView && _vm.bodyText
              ? _c("div", { staticClass: "bodyBox" }, [
                  _c("pre", [_vm._v(_vm._s(_vm.bodyText))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.dialogModel.checkBoxes, function (checkBox) {
              return _c("div", { key: checkBox.id, staticClass: "checkBox" }, [
                _c("input", {
                  ref: "checkbox-" + checkBox.id,
                  refInFor: true,
                  attrs: { id: checkBox.id, type: "checkbox" },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: checkBox.id } }, [
                  _vm._v("\n\t\t\t\t\t" + _vm._s(checkBox.text) + "\n\t\t\t\t"),
                ]),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.buttons.length && _vm.showButtons
          ? _c(
              "div",
              {
                ref: "dialogButtons",
                class: ["buttons", _vm.buttonHolderClass],
              },
              _vm._l(_vm.buttons, function (button) {
                return _c(
                  "div",
                  {
                    key: button.id,
                    staticClass: "dialogButtonWrapper",
                    attrs: { id: button.id },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "dialogButton",
                        on: {
                          click: function ($event) {
                            return _vm.selectButton(button.id)
                          },
                        },
                      },
                      [
                        button.image
                          ? _c("img", { attrs: { src: button.image } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.image ? _c("br") : _vm._e(),
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(button.text) + "\n\t\t\t\t"
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }